import { useTranslation } from "react-i18next";
import Global, { copyToClipBoard, formatLongNumber, getProcessingFee, isAdminAccount, isBusinessAccountType } from "../../util/Global";
import { useContext, useEffect, useState } from "react";
import { CurrencyContext, HintComponent } from "../Utils";
import { GlobalData } from "../../util/GlobalData";
import axios from "axios";
import { AlertContext } from "../../util/Alerter";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, CircularProgress, IconButton, Tooltip } from "@mui/material";
import CopyAllIcon from '@mui/icons-material/CopyAll';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Select, MenuItem, FormControl, InputLabel } from '@mui/material';

const STRIPE_ZERO_DECIMAL_CURRENCIES = new Set([
    "bif", "clp", "djf", "gnf", "jpy", "kmf", "krw", "mga", "pyg", "rwf", "ugx", "vnd", "vuv", "xaf", "xof", "xpf"
]);


export default function OrderSaleDetail({ passedData, isOrder, isSale }) {
    const { t } = useTranslation()
    const { showAlert } = useContext(AlertContext)
    const [data, setData] = useState(passedData)
    const [isUpdating, setisUpdating] = useState(false)
    const [isRefunding, setisRefunding] = useState(false)



    // my sales API
    const UPDATE_COMMANDES_URL = Global.backend + "/index.php/api/commande/updateDelivery";
    const REFUND_URL = Global.backend + "/index.php/api/commande/refundProduitVendu";

    // sales only
    function changeSaleStatus(product, status) {
        setisUpdating(true)

        axios.post(UPDATE_COMMANDES_URL, { soldProductId: product.id, statutLivraison: status }).then(() => {
            window.location.reload()
        }).catch((err) => {
            showAlert("error", t("request.errorUpdatingSaleStatus"))
        })
    }


    function refund(productId) {
        setisRefunding(true)
        axios.post(REFUND_URL, { productId }).then(() => {
            showAlert("success", t("successRefundingProduct"))
        }).catch(() => {
            showAlert("error", t("errorRefundingProduct"))
        }).finally(() => {
            setisRefunding(false)
        })
    }

    function getNormalizedRefundAmount(amount, currency) {
        const parsedAmount = Number(amount)

        if (Number.isNaN(parsedAmount)) {
            return amount
        }

        const isZeroDecimalCurrency = STRIPE_ZERO_DECIMAL_CURRENCIES.has((currency || "").toLowerCase())
        const isLikelyMinorUnit = Number.isInteger(parsedAmount) && parsedAmount >= 100

        if (!isZeroDecimalCurrency && isLikelyMinorUnit) {
            return parsedAmount / 100
        }

        return parsedAmount
    }

    function getStatusLabel(prefix, value) {
        if (!value) {
            return "-"
        }

        const key = prefix + value
        const translated = t(key)

        if (translated !== key) {
            return translated
        }

        return String(value).replaceAll("_", " ")
    }


    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-body">
                            <div
                                id="addproduct-nav-pills-wizard"
                                className="twitter-bs-wizard"
                            >
                                <div className=" twitter-bs-wizard-tab-content">




                                    <div className="tab-pane" id="basic-info">
                                        <h4 className="card-title">{t(isOrder ? "orderDetails" : isSale ? "saleDetails" : "")}</h4>
                                        <p className="card-title-desc"></p>


                                        <div className="row mb-3">

                                            <table className="table table-bordred">
                                                <tbody>
                                                    <tr>
                                                        <td>{t("reference")}</td>
                                                        <td>
                                                            {data.reference}
                                                            <Tooltip title={t("copy")}>
                                                                <IconButton onClick={() => {
                                                                    copyToClipBoard(data.reference)
                                                                }} color="primary">
                                                                    <CopyAllIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </td>
                                                    </tr>
                                                    {data.paymentIntent &&
                                                        <tr>
                                                            <td>
                                                                {t("stripePaymentIntent")}
                                                            </td>
                                                            <td>
                                                                {data.paymentIntent}
                                                                <Tooltip title={t("copy")}>
                                                                    <IconButton onClick={() => {
                                                                        copyToClipBoard(data.paymentIntent)
                                                                    }} color="primary">
                                                                        <CopyAllIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                {isAdminAccount() &&
                                                                    <Tooltip title={t("viewInStripe")}>
                                                                        <IconButton onClick={() => {
                                                                            window.open(Global.stripePaymentsLink + data.paymentIntent, '_blank');
                                                                        }} color="primary">
                                                                            <OpenInNewIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                }
                                                            </td>

                                                        </tr>
                                                    }

                                                    <tr>
                                                        <td>{t("createdAt")}</td>
                                                        <td>
                                                            {data.created_at}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>{t("comment")}</td>
                                                        <td>{data.commentaire || "-"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>{t("paymentCurrency")}</td>
                                                        <td>
                                                            {data.currency}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>{t("paymentMethod")}</td>
                                                        <td>{t("paymentMethods." + data.methode_de_paiement)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>{t("paymentStatus")}</td>
                                                        <td style={
                                                            data.statut_commande == "pending" ? {
                                                                backgroundColor: "orange",
                                                                color: "white",
                                                                borderColor: "orange",
                                                            } : data.statut_commande == "paid" ? {
                                                                backgroundColor: "green",
                                                                color: "white",
                                                                borderColor: "green",
                                                            } : data.statut_commande == "cancel" ? {
                                                                backgroundColor: "red",
                                                                color: "white",
                                                                borderColor: "red",
                                                            } : {}
                                                        }>{t("salesOrders.statusOrder." + data.statut_commande)}</td>
                                                    </tr>

                                                </tbody>
                                            </table>


                                        </div>
                                    </div>


                                    <hr />




                                    {isSale &&
                                        <>
                                            <div className="tab-pane" id="basic-info">
                                                <h4 className="card-title">{t("clientDetails")}</h4>
                                                <p className="card-title-desc"></p>


                                                <div className="row mb-3">
                                                    <table className="table table-bordred">
                                                        <tbody>
                                                            {isBusinessAccountType(data.user.compte) &&
                                                                <>
                                                                    <tr>
                                                                        <td>{t("companyName")}</td>
                                                                        <td>
                                                                            {(data.user.entreprise.nom)}
                                                                        </td>
                                                                    </tr>


                                                                    <tr>
                                                                        <td>{t("user.mail")}</td>
                                                                        <td>
                                                                            {(data.user.entreprise.email)}
                                                                        </td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td>{t("user.phone")}</td>
                                                                        <td>
                                                                            {(data.user.entreprise.tel)}
                                                                        </td>
                                                                    </tr>




                                                                    <tr>
                                                                        <td>{t("user.fax")}</td>
                                                                        <td>
                                                                            {(data.user.entreprise.fax)}
                                                                        </td>
                                                                    </tr>



                                                                    <tr>
                                                                        <td>{t("user.address")}</td>
                                                                        <td>
                                                                            {data.user.entreprise.adresse}
                                                                        </td>
                                                                    </tr>


                                                                    <tr>
                                                                        <td>{t("user.pays")}</td>
                                                                        <td>
                                                                            {data.user.entreprise.pays}
                                                                        </td>
                                                                    </tr>




                                                                    <tr>
                                                                        <td>{t("user.city")}</td>
                                                                        <td>
                                                                            {data.user.entreprise.ville}
                                                                        </td>
                                                                    </tr>



                                                                    <tr>
                                                                        <td>{t("user.postalCode")}</td>
                                                                        <td>
                                                                            {data.user.entreprise.code_postal}
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            }


                                                            <tr>
                                                                <td>{t(isBusinessAccountType(data.user.compte) ? "companyRepresentative" : "customerRepresentative")}</td>
                                                                <td>
                                                                    {(data.user.prenom + " " + data.user.nom)}
                                                                </td>
                                                            </tr>


                                                            <tr>
                                                                <td>{t("user.mail")}</td>
                                                                <td>
                                                                    {data.user.email}
                                                                </td>
                                                            </tr>




                                                            <tr>
                                                                <td>{t("user.phone")}</td>
                                                                <td>
                                                                    {data.user.telephone}
                                                                </td>
                                                            </tr>



                                                            <tr>
                                                                <td>{t("user.address")}</td>
                                                                <td>
                                                                    {data.user.adresse}
                                                                </td>
                                                            </tr>


                                                            <tr>
                                                                <td>{t("user.pays")}</td>
                                                                <td>
                                                                    {data.user.pays}
                                                                </td>
                                                            </tr>


                                                            <tr>
                                                                <td>{t("user.city")}</td>
                                                                <td>
                                                                    {data.user.ville}
                                                                </td>
                                                            </tr>



                                                            <tr>
                                                                <td>{t("user.postalCode")}</td>
                                                                <td>
                                                                    {data.user.code}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>


                                            <hr />
                                        </>
                                    }



                                    <div className="tab-pane" id="basic-info">
                                        <h4 className="card-title">{t("productDetails")}</h4>
                                        <p className="card-title-desc"></p>


                                        <div className="row mb-3">

                                            <TableContainer component={Paper}>
                                                <Table sx={{ borderCollapse: 'collapse', width: '100%' }}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{t("productName")}</TableCell>
                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{t("productCurrency")}</TableCell>
                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{t("price")}</TableCell>
                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{t("quantity")}</TableCell>
                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{t("deliveryFee")}</TableCell>
                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{t("total")}</TableCell>
                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{t("supplierDetails")}</TableCell>
                                                            {data.methode_de_paiement != "cashOnDelivery" &&
                                                                <>
                                                                    <TableCell sx={{ border: '1px solid #ddd' }}>{t("transferDetails")}</TableCell>
                                                                    <TableCell sx={{ border: '1px solid #ddd' }}>{t("refundDetails")}</TableCell>
                                                                </>
                                                            }
                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{t("paymentStatus")}</TableCell>
                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{t("deliveryStatus")}</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {data.produitVendus.map((product, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell sx={{ border: '1px solid #ddd' }}>{product.nom}</TableCell>
                                                                <TableCell sx={{ border: '1px solid #ddd' }}>{product.currency}</TableCell>
                                                                <TableCell sx={{ border: '1px solid #ddd' }}>
                                                                    <div style={{ display: "flex", alignItems: "center", fontSize: 17 }}>
                                                                        {product.discount ? (
                                                                            <span className="rounded-pill bg-success mr-1" style={{ color: "white" }}>
                                                                                {GlobalData.currency[product.currency]}{(product.prix - (product.prix * product.discount / 100))}
                                                                            </span>
                                                                        ) : (
                                                                            <span className="badge rounded-pill bg-success mr-1" style={{ color: "white" }}>
                                                                                {GlobalData.currency[product.currency]}{(product.prix)}
                                                                            </span>
                                                                        )}
                                                                        {product.discount && (
                                                                            <span>
                                                                                <span style={{
                                                                                    backgroundColor: "red", color: "white", padding: 2, borderRadius: 5, fontWeight: "bold"
                                                                                }} className="mr-1">
                                                                                    -{product.discount}%
                                                                                </span>
                                                                                <a className="text-muted">
                                                                                    <span style={{ textDecoration: "line-through" }}>
                                                                                        {GlobalData.currency[product.currency]}{(product.prix)}
                                                                                    </span>
                                                                                </a>
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell sx={{ border: '1px solid #ddd' }}>{product.quantite}</TableCell>
                                                                <TableCell sx={{ border: '1px solid #ddd' }}>{GlobalData.currency[data.currency]} {product.deliveryFee}</TableCell>
                                                                <TableCell sx={{ border: '1px solid #ddd', fontWeight: "bold" }}>
                                                                    {GlobalData.currency[data.currency]} {(product.totale + product.deliveryFee)}
                                                                </TableCell>

                                                                <TableCell sx={{ border: '1px solid #ddd' }}>
                                                                    <Table size="small">
                                                                        <TableBody>
                                                                            <TableRow>
                                                                                <TableCell sx={{ border: '1px solid #ddd' }}>{t("companyName")}</TableCell>
                                                                                <TableCell sx={{ border: '1px solid #ddd' }}>{product.fournisseur.entreprise.nom}</TableCell>
                                                                            </TableRow>
                                                                            <TableRow>
                                                                                <TableCell sx={{ border: '1px solid #ddd' }}>{t("user.mail")}</TableCell>
                                                                                <TableCell sx={{ border: '1px solid #ddd' }}>{product.fournisseur.entreprise.email}</TableCell>
                                                                            </TableRow>
                                                                            <TableRow>
                                                                                <TableCell sx={{ border: '1px solid #ddd' }}>{t("user.phone")}</TableCell>
                                                                                <TableCell sx={{ border: '1px solid #ddd' }}>{product.fournisseur.entreprise.tel}</TableCell>
                                                                            </TableRow>
                                                                            <TableRow>
                                                                                <TableCell sx={{ border: '1px solid #ddd' }}>{t("user.fax")}</TableCell>
                                                                                <TableCell sx={{ border: '1px solid #ddd' }}>{product.fournisseur.entreprise.fax}</TableCell>
                                                                            </TableRow>
                                                                            <TableRow>
                                                                                <TableCell sx={{ border: '1px solid #ddd' }}>{t("companyRepresentative")}</TableCell>
                                                                                <TableCell sx={{ border: '1px solid #ddd' }}>{product.fournisseur.prenom + " " + product.fournisseur.nom}</TableCell>
                                                                            </TableRow>
                                                                            <TableRow>
                                                                                <TableCell sx={{ border: '1px solid #ddd' }}>{t("user.mail")}</TableCell>
                                                                                <TableCell sx={{ border: '1px solid #ddd' }}>{product.fournisseur.email}</TableCell>
                                                                            </TableRow>
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableCell>

                                                                {data.methode_de_paiement != "cashOnDelivery" &&
                                                                    <>
                                                                        <TableCell sx={{ border: '1px solid #ddd' }}>
                                                                            {product.transfer ?
                                                                                <Table size="small">
                                                                                    <TableBody>
                                                                                        <TableRow>
                                                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{t("stripeTransferReference")}</TableCell>
                                                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{product.transfer.transferReference}
                                                                                                <Tooltip title={t("copy")}>
                                                                                                    <IconButton onClick={() => {
                                                                                                        copyToClipBoard(product.transfer.transferReference)
                                                                                                    }} color="primary">
                                                                                                        <CopyAllIcon />
                                                                                                    </IconButton>
                                                                                                </Tooltip>
                                                                                                {isAdminAccount() &&
                                                                                                    <Tooltip title={t("viewInStripe")}>
                                                                                                        <IconButton onClick={() => {
                                                                                                            window.open(Global.stripeTransfersLink + product.transfer.transferReference, '_blank');
                                                                                                        }} color="primary">
                                                                                                            <OpenInNewIcon />
                                                                                                        </IconButton>
                                                                                                    </Tooltip>
                                                                                                }
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                        <TableRow>
                                                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{t("transferCurrency")}</TableCell>
                                                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{product.transfer.currency}</TableCell>
                                                                                        </TableRow>
                                                                                        <TableRow>
                                                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{t("amount")}</TableCell>
                                                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{GlobalData.currency[product.transfer.currency]}{product.transfer.amount}</TableCell>
                                                                                        </TableRow>
                                                                                        <TableRow>
                                                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{t("status")}</TableCell>
                                                                                            <TableCell sx={{ border: '1px solid #ddd' }} style={
                                                                                                product.transfer.status == "refund" ? {
                                                                                                    backgroundColor: "blue",
                                                                                                    color: "white",
                                                                                                    borderColor: "blue",
                                                                                                } : product.transfer.status == "success" ? {
                                                                                                    backgroundColor: "green",
                                                                                                    color: "white",
                                                                                                    borderColor: "green",
                                                                                                } : {}}>{t("salesOrders.statusTransfer." + product.transfer.status)}
                                                                                            </TableCell>
                                                                                        </TableRow>

                                                                                    </TableBody>
                                                                                </Table>
                                                                                :
                                                                                "-"
                                                                            }
                                                                        </TableCell>

                                                                        <TableCell sx={{ border: '1px solid #ddd' }}>
                                                                            {product.refund ?
                                                                                <Table size="small">
                                                                                    <TableBody>
                                                                                        <TableRow>
                                                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{t("stripeRefundReference")}</TableCell>
                                                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{product.refund.refundReference}
                                                                                                <Tooltip title={t("copy")}>
                                                                                                    <IconButton onClick={() => {
                                                                                                        copyToClipBoard(product.refund.refundReference)
                                                                                                    }} color="primary">
                                                                                                        <CopyAllIcon />
                                                                                                    </IconButton>
                                                                                                </Tooltip>
                                                                                                {isAdminAccount() &&
                                                                                                    <Tooltip title={t("viewInStripe")}>
                                                                                                        <IconButton onClick={() => {
                                                                                                            window.open(Global.stripePaymentsLink + data.paymentIntent, '_blank');
                                                                                                        }} color="primary">
                                                                                                            <OpenInNewIcon />
                                                                                                        </IconButton>
                                                                                                    </Tooltip>
                                                                                                }
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                        <TableRow>
                                                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{t("refundReference")}<HintComponent text={t("refundReferenceHint")} /></TableCell>
                                                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{product.refund.arn || "-"}
                                                                                                {product.refund.arn && <Tooltip title={t("copy")}>
                                                                                                    <IconButton onClick={() => {
                                                                                                        copyToClipBoard(product.refund.arn)
                                                                                                    }} color="primary">
                                                                                                        <CopyAllIcon />
                                                                                                    </IconButton>
                                                                                                </Tooltip>}
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                        <TableRow>
                                                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{t("refundCurrency")}</TableCell>
                                                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{product.refund.currency}</TableCell>
                                                                                        </TableRow>
                                                                                        <TableRow>
                                                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{t("amount")}</TableCell>
                                                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{GlobalData.currency[product.refund.currency]}{formatLongNumber(getNormalizedRefundAmount(product.refund.amount, product.refund.currency))}</TableCell>
                                                                                        </TableRow>
                                                                                        <TableRow>
                                                                                            <TableCell sx={{ border: '1px solid #ddd' }}>{t("status")}</TableCell>
                                                                                            <TableCell sx={{ border: '1px solid #ddd' }} style={
                                                                                                product.refund.status == "pending" ? {
                                                                                                    backgroundColor: "orange",
                                                                                                    color: "white",
                                                                                                    borderColor: "orange",
                                                                                                } : product.refund.status == "success" ? {
                                                                                                    backgroundColor: "green",
                                                                                                    color: "white",
                                                                                                    borderColor: "green",
                                                                                                } : product.refund.status == "cancel" ? {
                                                                                                    backgroundColor: "red",
                                                                                                    color: "white",
                                                                                                    borderColor: "red",
                                                                                                } : {}}>{t("salesOrders.statusRefund." + product.refund.status)}
                                                                                            </TableCell>
                                                                                        </TableRow>

                                                                                    </TableBody>
                                                                                </Table>
                                                                                :
                                                                                "-"
                                                                            }
                                                                        </TableCell>
                                                                    </>
                                                                }
                                                                <TableCell style={
                                                                    product.status == "pending" ? {
                                                                        backgroundColor: "orange",
                                                                        color: "white",
                                                                        borderColor: "orange",
                                                                    } : product.status == "pending_transfer" ? {
                                                                        backgroundColor: "#f59e0b",
                                                                        color: "white",
                                                                        borderColor: "#f59e0b",
                                                                    } : product.status == "paid" ? {
                                                                        backgroundColor: "green",
                                                                        color: "white",
                                                                        borderColor: "green",
                                                                    } : product.status == "refund" ? {
                                                                        backgroundColor: "blue",
                                                                        color: "white",
                                                                        borderColor: "blue",
                                                                    } : product.status == "cancel" ? {
                                                                        backgroundColor: "red",
                                                                        color: "white",
                                                                        borderColor: "red",
                                                                    } : {}
                                                                }>{getStatusLabel("salesOrders.statusProduct.", product.status)}</TableCell>

                                                                <TableCell sx={{ border: '1px solid #ddd' }}>
                                                                    {(isSale || isAdminAccount()) && !product.refund ? (
                                                                        <div style={{ textAlign: "center", display: "flex", flexDirection: "column", gap: "1rem" }}>
                                                                            <Select
                                                                                disabled={isUpdating || (product.status != "paid" && data.methode_de_paiement!="cashOnDelivery")}
                                                                                onChange={(e) => changeSaleStatus(product, e.target.value)}
                                                                                value={product.statut_livraison}
                                                                                sx={{
                                                                                    backgroundColor: product.statut_livraison === "En Cours" ? "orange" :
                                                                                        product.statut_livraison === "Livrée" ? "green" :
                                                                                            product.statut_livraison === "En attente de transfert" ? "#f59e0b" :
                                                                                            product.statut_livraison === "Annulée" ? "red" : "",
                                                                                    color: "white",
                                                                                    borderColor: product.statut_livraison === "En Cours" ? "orange" :
                                                                                        product.statut_livraison === "Livrée" ? "green" :
                                                                                            product.statut_livraison === "En attente de transfert" ? "#f59e0b" :
                                                                                            product.statut_livraison === "Annulée" ? "red" : "",
                                                                                }}
                                                                            >
                                                                                {GlobalData.salesOrders.statusDelivery.map((val, i) => (
                                                                                    <MenuItem key={i} value={val}>
                                                                                        {getStatusLabel("salesOrders.statusDelivery.", val)}
                                                                                    </MenuItem>
                                                                                ))}
                                                                            </Select>
                                                                            <Button className="btn btn-primary" variant="contained" color="primary" disabled={isRefunding || product.status != "paid"} onClick={() => { refund(product.id) }}>
                                                                                {isRefunding ?
                                                                                    <CircularProgress size={25} />
                                                                                    :
                                                                                    t("refund")
                                                                                }
                                                                            </Button>
                                                                        </div>
                                                                    ) : (
                                                                        <div style={{
                                                                            backgroundColor: product.statut_livraison === "En Cours" ? "orange" :
                                                                                product.statut_livraison === "Livrée" ? "green" :
                                                                                    product.statut_livraison === "En attente de transfert" ? "#f59e0b" :
                                                                                    product.statut_livraison === "Annulée" ? "red" : "",
                                                                            color: "white", padding: "5px 10px", borderRadius: 5
                                                                        }}>
                                                                            {getStatusLabel("salesOrders.statusDelivery.", product.statut_livraison)}
                                                                        </div>
                                                                    )}
                                                                </TableCell>

                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>



                                        <div className="row">
                                            {isOrder &&
                                                <div className="col-md-12">
                                                    <h4 style={{ marginBottom: data.methode_de_paiement === "stripe" && data.stripeFee != null ? 4 : 0 }}>
                                                        {t("processingFee")}: {GlobalData.currency[data.currency]} {data.processingFee.toFixed(2)}
                                                    </h4>
                                                    {data.methode_de_paiement === "stripe" && data.stripeFee != null && (
                                                        <div className="text-muted" style={{ fontSize: "0.9rem", marginTop: 2 }}>
                                                            <span title={t("processingFeeStripeBreakdown")}>
                                                                {t("stripeFeeAmount")}: {GlobalData.currency[data.stripeFeeCurrency || data.stripeSettlementCurrency] || ""}{Number(data.stripeFee).toFixed(2)} {data.stripeFeeCurrency || data.stripeSettlementCurrency}
                                                                {data.stripeExchangeRate && data.stripeSettlementCurrency && (
                                                                    <> · {t("exchangeRateLabel")}: 1 {data.currency} = {Number(data.stripeExchangeRate).toFixed(2)} {data.stripeSettlementCurrency}</>
                                                                )}
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                            }
                                            <div className="col-md-9" style={{ display: "flex", alignItems: "center" }}>
                                                <h3>{t("total")}: {GlobalData.currency[data.currency]} {formatLongNumber(data.totale)}</h3>

                                            </div>


                                            <div className="col-md-3">
                                                <button
                                                    className="ttm-btn ttm-btn-size-md ttm-btn-shape-rounded ttm-btn-style-fill ttm-btn-color-skincolor d-print-none"

                                                    onClick={() => {
                                                        let sidebarClosed = false
                                                        if (document.querySelector(".sidebar-enable")) {
                                                            document.getElementById("vertical-menu-btn").click()
                                                            sidebarClosed = true
                                                        }
                                                        setTimeout(() => {
                                                            window.print()
                                                            if (sidebarClosed) {
                                                                document.getElementById("vertical-menu-btn").click()
                                                            }
                                                        }, 100)

                                                    }}
                                                >
                                                    {t("downloadFacture")}
                                                </button>
                                            </div>

                                        </div>
                                    </div>



                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >

    )
}